import './scss/app.scss';
import 'slick-carousel/slick/slick.css'
var $ = require( "jquery" );
import 'slick-carousel';

window.$ = $;
var jQery = $;

$(document).ready(function() {
  // slider inner content
  var sliderImpression = $('.slider-impressionen');
  console.log(sliderImpression);
  sliderImpression.slick({
    slidesToShow: 4,
          pauseOnFocus: false,
          pauseOnHover: false,
    variableWidth: true,
    prevArrow: '<button type="button" class="slick-prev ffff">Previous</button>',
    nextArrow: '<button type="button" class="slick-next">Next</button>'
  });	
})
